import { useCallback } from 'react';
import { useInReverseTrial } from '@atlassian/jira-reverse-trial-utils/src/controllers/use-in-reverse-trial/index.tsx';
import { PREMIUM_REVERSE_TRIAL_TASK } from '@atlassian/jira-onboarding-quickstart-core/src/common/constants.tsx';
import { useJswOnboarding } from '@atlassian/jira-onboarding-quickstart-core/src/services/index.tsx';
import { useOpenChecklist } from '@atlassian/jira-software-onboarding-quickstart/src/controllers/open-checklist/index.tsx';

type ReverseTrialInfo = {
	isReady: boolean;
	isInReverseTrial: boolean | undefined;
	onOpenOnboardingMenu: (() => void) | undefined;
};

/**
 * Condenses some logic from the Reverse Trial Dropdown. This is used
 * to integrate Jira with the AudienceAndTiming code in Platform.
 * The majority of this code can be removed once `jira_rt_quickstart_m1`
 * is cleaned up due to its inclusion in a holdout
 * @returns { isInReverseTrial, onOpenOnboardingMenu }
 */
export const useReverseTrials = (): ReverseTrialInfo => {
	const openChecklist = useOpenChecklist();
	const [{ currentTaskGroupParent }, { changeTaskGroupParent }] = useJswOnboarding();

	const { isInReverseTrial, isReady: isRTReady } = useInReverseTrial();

	const onOpenOnboardingMenu = useCallback(() => {
		const taskGroupToEnter = PREMIUM_REVERSE_TRIAL_TASK;

		if (currentTaskGroupParent !== taskGroupToEnter) {
			changeTaskGroupParent(taskGroupToEnter);
		}

		openChecklist({
			trigger: 'ReverseTrialPopup',
		});
	}, [currentTaskGroupParent, openChecklist, changeTaskGroupParent]);

	if (!isRTReady) {
		return {
			isReady: false,
			isInReverseTrial: undefined,
			onOpenOnboardingMenu: undefined,
		};
	}

	return {
		isReady: true,
		isInReverseTrial,
		onOpenOnboardingMenu,
	};
};
